import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Application } from '../types/application.type';
import { HowHeard } from '../types/how-heard.type';
import { Lead } from '../types/lead.type';
import { IAppSettings, APP_CONFIG } from '@nha/config/interfaces/iapp-settings.interface';

@Injectable()
export class SaveService {
	appSettings = inject<IAppSettings>(APP_CONFIG);
	serviceUrl = this.appSettings.api.application;
	
	constructor(private http: HttpClient) {}

	createLead(lead: Lead): Observable<Lead> {
		return this.http.post<Lead>(`${this.serviceUrl}/lead`, lead);
	}

	updateLead(lead: Lead): Observable<Lead> {
		return this.http.put<Lead>(`${this.serviceUrl}/lead`, lead);
	}

	saveHowHeard(howHeard: HowHeard): Observable<any> {
		return this.http.post(`${this.serviceUrl}/lead/how-heard`, howHeard);
	}

	saveApplication(application: Application): Observable<any> {
		return this.http.post(`${this.serviceUrl}/save`, application);
	}
}
